// extracted by mini-css-extract-plugin
export default {"parentView":"style_parentView__oqy8z","time":"style_time__JlbTY","animate":"style_animate__0q26k","pop":"style_pop__J7imV"};